import { ComponenteCalcular } from "../types";

export const formatarComponentesCalcular = (items: ComponenteCalcular[]): ComponenteCalcular[] => {
  const comps: ComponenteCalcular[] = []
  for (const item of items) {
    comps.push({
      altura: item.altura,
      categoria_componentes_id: item.categoria_componentes_id,
      componente_id: item.componente_id,
      quantidade: item.quantidade,
      largura: item.largura,
      peso: item.peso,
      potencia: item.potencia,
      valor: 0,
    })   
  }
  return comps;
}